module.exports = __webpack_public_path__ + "../assets/img/e3ac952c2371db205b6eef0779cd64a0.svg";